import { LocalStorageService } from '../../services/storage/local-storage.service';

export class BaseCloseNotification  {

  constructor(protected localStorageService: LocalStorageService,
              private storageKey: string) {
  }

  isNotificationClosed(): boolean {
    return this.localStorageService.getItem(this.storageKey) === 'true';
  }

  closeNotification(): void {
    this.localStorageService.setItem(this.storageKey, 'true');
  }
}
